module.exports = __webpack_public_path__ + "static/media/cube.00f9a34e.svg";